export const getDepositStatement = () =>
    `By submitting, you acknowledge your consent to debit your linked account via ACH. Your funds will be cleared through Kalshi Klear`;

export const marketManipulationStatementPart1 = 'By continuing, you acknowledge and agree to Kalshi’s legal terms,';
export const marketManipulationStatementPart2 = 'which we recommend reviewing ';
export const marketManipulationStatement = `${marketManipulationStatementPart1} ${marketManipulationStatementPart2} `;
